import { Microfrontend } from '@cian/mf-react';

import * as React from 'react';

import { useContext } from '../../utils/useContext';

export const EarlyAccessPaywallModalContainer: React.FC = () => {
  const context = useContext();

  if (context.status !== 'succeed') {
    return null;
  }

  const { microfrontendRef, manifest, params } = context;

  return (
    <Microfrontend
      image={manifest.imageVersion}
      instance={manifest.instanceId}
      name={manifest.microfrontendName}
      parameters={params}
      ref={microfrontendRef}
      runtime={manifest.runtimeName}
    />
  );
};
